import React, { useState, useEffect} from 'react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import styles from '@styles/punch.module.css';
import { isAuthenticated } from '@actions/authentication';
import { withCookies } from 'react-cookie';
import { RenewToken } from '@utils/token';
import HRRequestTabPanel from './HRRequestTabPanel';

function HRRequest(props) {
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        handleTitle();
        handleToken();
    }, []);

    const handleToken = async () => {
        await RenewToken(props);
        const result = await isAuthenticated();
        setAuthenticated(result);
    };

    const handleTitle = () => {
        props.onLoadTitle(i18next.t('menu:hrRequest'));
    };

    return (
        authenticated && (
            <div className={styles.rootHRRequest}>
                <HRRequestTabPanel />
            </div>
        )
    );
}

export default withNamespaces(['menu'], { wait: true })(
    withCookies(HRRequest)
);
